import { put, all, call } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/enterprisePersonnel/messages";
import SessionClient from "util/SessionClient";

// The accepted seat changes the user's roles and permissions, so the refreshed
// session has to land before consumers react to the success event and navigate.
const reloadSession = (session) => session.user?.reload("accept-seat-invite")?.catch(() => null);

function* acceptSeatInvite(action) {
  const { pendingSeatId, pendingSponsorId } = action.payload;
  const session = new SessionClient();

  const params = { sponsor_id: pendingSponsorId };
  const { success, data, error } = yield* makeRequest.patch(`/pending_seats/${pendingSeatId}/accept`, params);

  if (success && data) {
    if (data.body?.banners) {
      session.banners = data.body.banners;
      yield put(actions.setBanners(data.body.banners));
      if (!data.body.banners.length) {
        yield put(actions.setBannersHeight(0));
      }
    }

    yield call(reloadSession, session);

    yield all([
      // put(actions.setEnterpriseServicesSeatChangePreview({})),
      put(
        actions.newSuccessEvent({
          message: messages.ACCEPT_SEAT_INVITE_SUCCESS,
        }),
      ),
    ]);
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_ACCEPTING_SEAT_INVITE,
    });
  }

  return null;
}

export default acceptSeatInvite;
